import { createLucideIcon } from 'lucide-react';

export const UsersCog = createLucideIcon('user-cog', [
  [
    'path',
    {
      d: 'M13 9C13 6.78906 14.7891 5 17 5C19.2109 5 21 6.78906 21 9C21 11.2109 19.2109 13 17 13C14.7891 13 13 11.2109 13 9Z',
      key: 'c2bpgg',
    },
  ],
  [
    'path',
    {
      d: 'M17 13C12 13.2157 12 19 12 19',
      key: '1qhdqf',
    },
  ],
  [
    'path',
    {
      d: 'M18.4999 17L17.274 16.2',
      key: '1pvk7t',
    },
  ],
  [
    'path',
    {
      d: 'M18.4999 19.2L17.274 19.8',
      key: 'atff42',
    },
  ],
  [
    'path',
    {
      d: 'M2 19C2 19 2 13 7 13C12 13 12 19 12 19',
      key: '1r2hkw',
    },
  ],
  [
    'path',
    {
      d: 'M20.0998 15V16.2',
      key: '1v6oiv',
    },
  ],
  [
    'path',
    {
      d: 'M20.0998 19.8V21',
      key: 'l07liw',
    },
  ],
  [
    'path',
    {
      d: 'M20.1 19.8C21.0941 19.8 21.9 18.9941 21.9 18C21.9 17.0059 21.0941 16.2 20.1 16.2C19.1059 16.2 18.3 17.0059 18.3 18C18.3 18.9941 19.1059 19.8 20.1 19.8Z',
      key: '1wp4rb',
    },
  ],
  [
    'path',
    {
      d: 'M21.6289 17L22.9078 16.2',
      key: '14153r',
    },
  ],
  [
    'path',
    {
      d: 'M21.6289 19.2L22.9078 19.9258',
      key: '1ke0is',
    },
  ],
  [
    'path',
    {
      d: 'M3 9C3 6.78906 4.78906 5 7 5C9.21094 5 11 6.78906 11 9C11 11.2109 9.21094 13 7 13C4.78906 13 3 11.2109 3 9Z',
      key: 'yqf7k3',
    },
  ],
]);
